import { render, staticRenderFns } from "./accordion-reporting.vue?vue&type=template&id=3ae665fc"
import script from "./accordion-reporting.ts?vue&type=script&lang=ts&external"
export * from "./accordion-reporting.ts?vue&type=script&lang=ts&external"
import style0 from "./accordion-reporting.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ae665fc')) {
      api.createRecord('3ae665fc', component.options)
    } else {
      api.reload('3ae665fc', component.options)
    }
    module.hot.accept("./accordion-reporting.vue?vue&type=template&id=3ae665fc", function () {
      api.rerender('3ae665fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/reporting/accordion-reporting/accordion-reporting.vue"
export default component.exports